//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'bing-map',
  props: {
    mapData: {
      type: Array,
      default(){
        return [];
      },
    },
    isUnitHotel: {
      type: Boolean,
      default: false,
    },
  },
  data(){
    return {
      map: null,
      zIndex: 2019,
      prevInfoBox: null,
    };
  },
  mounted(){
    this.init();
  },
  watch: {
    mapData(){
      this.init();
    },
  },
  methods: {
    init () {
      let timer = null;
      let count = 0;

      this.$vux.loading.show();
      clearInterval(timer);
      timer = setInterval(() => {
        if(count > 20){
          clearInterval(timer);
          this.$vux.loading.hide();
        }

        if(typeof Microsoft != 'undefined' && Microsoft.Maps.Map){
          const len = this.mapData.length;

          this.map = new Microsoft.Maps.Map('#bingMap', {
            credentials: 'Ah3RA4ugmoCv8MDPM5ZK-Ec8fCAEQShv_PWpcRnb7qeUwFuYqmwYUUeegbzvtDEM',
            zoom: 14,
          });

          if(len > 0){
            const centerData = this.mapData[Math.floor(len / 2)];
            const centerLoc = new Microsoft.Maps.Location(centerData.latitude, centerData.longitude);

            this.map.setView({
              center: centerLoc,
            });

            if(this.isUnitHotel){
              this.setPushpin(centerLoc);
            }else{
              this.renderPriceBox();
            }
          }else{
            this.getCurrentPosition();
          }

          clearInterval(timer);
          this.$vux.loading.hide();
        }
        ++count;
      }, 500);
    },

    /** 价格显示标记 */
    renderPriceBox(){
      this.mapData.forEach((itm, idx) => {
        let that = this;
        let location = new Microsoft.Maps.Location(itm.latitude, itm.longitude);
        let boxTpl = '';
        if(itm.min_price.price){
          boxTpl = `<div class="info-box">${itm.min_price.currency_code} ${parseInt(itm.min_price.price)}<i></i></div>`;
        }else{
          boxTpl = `<div class="info-box">${that.$i18n.t('hotel.PHONE_ASK')}<i></i></div>`;
        }

        let infoBox = new Microsoft.Maps.Infobox(location, {
          htmlContent: boxTpl,
          visible: true,
        });

        infoBox.setMap(this.map);
        this.bindEvent(infoBox, idx);
        // this.setPushpin(location);
      });
    },

    /** 设置地点圆环标记 */
    setPushpin(center){
      let pin = new Microsoft.Maps.Pushpin(center, {
        color: '#0097FF',
      });

      this.map.entities.push(pin);
    },

    /** 获取用户当前位置经纬度 */
    getCurrentPosition(){
      navigator.geolocation.getCurrentPosition(function (position) {
        let loc = new Microsoft.Maps.Location(position.coords.latitude, position.coords.longitude);

        this.map.setView({center: loc});
      });
    },

    /** 给价格展示框绑定事件 */
    bindEvent(infoBox, dataIdx){
      Microsoft.Maps.Events.addHandler(infoBox, 'click', ev => {
        const curInfoBox = ev.target;

        if(this.prevInfoBox){
          this.prevInfoBox.setOptions({visible: true});
        }

        this.$emit('on-data-index', dataIdx);
        // 兼容点击第二个infoBox，会隐藏第一个的bug
        this.prevInfoBox = curInfoBox;
        curInfoBox.setOptions({zIndex: this.zIndex, visible: true, backgroundColor: 'red'});

        const curInfobox = document.querySelectorAll('.info-box')[dataIdx];

        this.resetInfoBoxOpts();
        curInfobox.style.backgroundColor = '#EA3C3C';
        curInfobox.querySelector('i').style.background = 'url("/m/static/images/map-arrow-down-red.png") no-repeat center center';
        curInfobox.querySelector('i').style.backgroundSize = '11px 7px';
        // curInfobox.querySelector('i').style.zIndex = this.zIndex + 1;
        this.zIndex++;
      });
    },

    /** 重置infobox的样式 */
    resetInfoBoxOpts(){
      const infoBox = document.querySelectorAll('.info-box');

      infoBox.forEach((it, idx) => {
        it.style.backgroundColor = '#0097FF';
        it.querySelector('i').style.background = 'url("/m/static/images/map-arrow-down-blue.png") no-repeat center center';
        it.querySelector('i').style.backgroundSize = '11px 7px';
      });
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/BingMap/BingMap.vue